module.exports = "<p>\n  {{'ROUTE_NOT_FOUND.DESCRIPTION' | translate}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/route-not-found/route-not-found.component.html
// module id = FS9g
// module chunks = 0